import request from '@/utils/request'


// 查询调拨单列表
export function listOrderTransfer(query) {
  return request({
    url: '/biz/admin/order/transfer/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询调拨单分页
export function pageOrderTransfer(query) {
  return request({
    url: '/biz/admin/order/transfer/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询调拨单详细
export function getOrderTransfer(data) {
  return request({
    url: '/biz/admin/order/transfer/detail',
    method: 'get',
    params: data
  })
}

// 新增调拨单
export function addOrderTransfer(data) {
  return request({
    url: '/biz/admin/order/transfer/add',
    method: 'post',
    data: data
  })
}

// 修改调拨单
export function updateOrderTransfer(data) {
  return request({
    url: '/biz/admin/order/transfer/edit',
    method: 'post',
    data: data
  })
}

// 删除调拨单
export function delOrderTransfer(data) {
  return request({
    url: '/biz/admin/order/transfer/delete',
    method: 'post',
    data: data
  })
}


export function orderTransferGoodsImport(data) {
  return request({
    url: '/biz/admin/order/transfer/import',
    method: 'post',
    data: data
  })
}
